exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-module {\n    position: relative;\n    z-index: 2;\n}\n", ""]);

// exports
